export enum IdentifierType {
    Tag,
    CalculatedValue,
    Linked,
    Validated,
    Target
}